import { render, staticRenderFns } from "./side-nav-menu.vue?vue&type=template&id=72b05178&"
import script from "./side-nav-menu.vue?vue&type=script&lang=js&"
export * from "./side-nav-menu.vue?vue&type=script&lang=js&"
import style0 from "./side-nav-menu.vue?vue&type=style&index=0&id=72b05178&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports